import React, { LegacyRef, ReactNode, useEffect, useState } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { Icon } from '../Icon'
// import UIRadio from './UIRadio'
import { getGroupsSchoolsData } from '../../api/schools/schools'
import Loading from './Loading'
import UISwitch from './UISwitch'
import { useToggledSwitches } from '../../context/ToggledSwitchesContext'

export interface MenuItemInterface {
  label?: string
  onClick?: () => void
  icon: string
  iconColor?: string
  textColor?: string
}

interface MenuProps {
  isOpen: boolean
  items: MenuItemInterface[]
  children: ReactNode
  type?: string
  wrapperRefScrollMenu: LegacyRef<HTMLDivElement> | undefined
  display?: boolean
}

const UISchoolMenu: React.FC<MenuProps> = ({
  isOpen,
  children,
  type,
  wrapperRefScrollMenu,
  display,
}) => {
  const queryClient = useQueryClient()
  const { setSchoolCount } = useToggledSwitches()
  const { toggledSwitches, setToggledSwitches, setSchoolId } =
    useToggledSwitches()

  // Initialize switch values as an array with the first switch set to true
  const [switchValue, setSwitchValue] = useState<boolean[]>([true])

  const traningRecords = useQuery('schools', () => getGroupsSchoolsData(), {
    enabled: isOpen, // Only fetch data when the component is open
  })

  useEffect(() => {
    queryClient.invalidateQueries('schools')
    traningRecords.refetch()
  }, [])

  useEffect(() => {
    // Set the initial selected option to the ID of the first option
    if (
      traningRecords &&
      traningRecords.data &&
      traningRecords?.data.data.length > 0
    ) {
      setSchoolId(traningRecords?.data.data[0]?.id?.toString())
      // Add the ID of the first option to the toggledSwitches array
      const dataIds = traningRecords?.data.data[0]?.id?.toString()
      localStorage.setItem('SchoolIds', JSON.stringify([dataIds]))
      setToggledSwitches([traningRecords?.data.data[0]?.id?.toString()])
    }
  }, [traningRecords.data])

  const handleSwitchChange = (id: string, value: boolean) => {
    setSwitchValue((prevState) => {
      const newState = [...prevState]
      const index = traningRecords?.data?.data?.findIndex(
        (option) => option.id?.toString() === id
      )
      if (index !== undefined && index !== -1) {
        newState[index] = value
      }
      return newState
    })
    if (value) {
      setToggledSwitches((prevState) => [...prevState, id])
    } else {
      setToggledSwitches((prevState) =>
        prevState.filter((switchId) => switchId !== id)
      )
    }
  }

  useEffect(() => {
    if (traningRecords.data) {
      setSchoolCount(traningRecords?.data?.data?.length)
    }
  }, [traningRecords.data])

  useEffect(() => {
    localStorage.setItem('SchoolIds', JSON.stringify(toggledSwitches))
  }, [toggledSwitches])


  return (
    <>
      <div
        ref={wrapperRefScrollMenu}
        className={`${type == 'table' ? 'absolute' : 'relative'} ${display ? 'hidden' : 'flex'} `}
      >
        {children}
        {isOpen && (
          <div className="absolute right-0 mt-10 w-[450px] h-[480px] bg-white rounded-lg z-20 cursor-pointer shadow-lg">
            <div className="w-[100%] h-[48px] gap-[10px] bg-gray2 rounded-t-lg flex items-center px-[10px]">
              <Icon
                name={'IconBuilding'}
                stroke={'#02698C'}
                width={16}
                height={16}
                strokeWidth={2}
              />
              <p className="text-bluishGreen font-semibold text-[14px]">
                My Institutions
              </p>
            </div>
            <div className="flex-col h-[420px] w-[100%] p-[10px] overflow-scroll overflow-hidden">
              {traningRecords.isLoading && (
                <div className="flex-col h-[400px] w-[100%] p-[10px]">
                  <Loading size="small" />
                </div>
              )}
              {!traningRecords.isLoading && (
                <div>
                  {traningRecords?.data?.data?.map((option, index) => (
                    <div
                      key={index}
                      className="radio-button-container  flex justify-end my-[8px] items-center w-[100%]"
                    >
                      <div className="w-[100%] p-[15px] flex justify-between items-start rounded-[12px] h-[84px] bg-gray1">
                        <div className="flex items-center gap-[10px]">
                          <div className="bg-white p-2 rounded-[10px]">
                            <Icon
                              name={'IconBuilding'}
                              stroke={'#02698C'}
                              width={25}
                              height={25}
                              strokeWidth={2}
                            />
                          </div>
                          <div className="flex-col">
                            <p className="text-text1 font-semibold text-[14px]">
                              {option.name}
                            </p>
                            <div className="flex justify-center items-center">
                              <Icon
                                name={'IconMarkerPin'}
                                stroke={'#02698C'}
                                width={12}
                                height={12}
                                strokeWidth={1}
                              />
                              <p className="text-text1 font-medium text-[12px]">
                                Bowes Rd, Arnos Grove, London N11 2HL
                              </p>
                            </div>
                          </div>
                        </div>
                        <UISwitch
                          value={switchValue[index]} // Pass the value corresponding to the current index
                          onValueChange={(value) =>
                            handleSwitchChange(option.id?.toString(), value)
                          }
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default UISchoolMenu
